import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../../layout/Layout";
import PageBanner from "../../layout/PageBanner";
import { catalogService } from "../../services";
import { SkeletonGrid, Switch } from "../../components/ui";

const GameTile = ({ game }) => (
  <Link to={`/topup/game/${game.id}/${game.slug}`} className="lt-tile">
    <div className="lt-tile__image">
      <img src={game.image} alt={game.name} loading="lazy" />
      {game.promo ? <span className="lt-tile__badge">PROMO</span> : null}
      {!game.available ? <div className="lt-tile__off">ปิดปรับปรุง</div> : null}
    </div>
    <div className="lt-tile__name">{game.name}</div>
  </Link>
);

export default function GameList() {
  const [games, setGames] = useState(null);
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({ instant: false, promo: false, available: false });

  useEffect(() => {
    let alive = true;
    catalogService.games().then((rows) => alive && setGames(rows || []));
    return () => {
      alive = false;
    };
  }, []);

  const filtered = useMemo(() => {
    if (!games) return null;
    return games.filter((game) => {
      if (search && !game.name.toLowerCase().includes(search.toLowerCase())) return false;
      if (filters.instant && !game.instant) return false;
      if (filters.promo && !game.promo) return false;
      if (filters.available && !game.available) return false;
      return true;
    });
  }, [games, search, filters]);

  const groups = useMemo(() => {
    if (!filtered) return [];
    return [
      { key: "th", title: "Game Server (TH)", rows: filtered.filter((game) => game.server === "th") },
      { key: "other", title: "Game Server (Other)", rows: filtered.filter((game) => game.server === "other") },
    ].filter((group) => group.rows.length > 0);
  }, [filtered]);

  return (
    <Layout>
      <PageBanner title="เติมเกม" breadcrumb={[{ label: "เติมเกม" }]} seed={2} />

      <div className="lucid-container" style={{ marginTop: -30, position: "relative", zIndex: 3, paddingBottom: 40 }}>
        <div className="lt-flex lt-flex-wrap lt-gap-8 lt-mb-24" style={{ justifyContent: "center" }}>
          {["เติมเกมออนไลน์", "เข้าทันที 24 ชม.", "เติมเงินมือถือ", "โปรโมชั่นทุกเดือน", "เติมผ่าน UID"].map((chip) => (
            <span key={chip} className="lt-btn lt-btn--ghost lt-btn--pill">
              {chip}
            </span>
          ))}
        </div>

        <div className="lt-list-layout">
          <aside className="lt-filter">
            <h3>ตัวกรองเกม</h3>
            <p className="lt-filter__hint">พบทั้งหมด {filtered ? filtered.length : 0} รายการ</p>

            <input
              className="lt-input"
              placeholder="ค้นหาชื่อเกมที่ต้องการ"
              value={search}
              onChange={(event) => setSearch(event.target.value)}
            />

            <div className="lt-filter__group">
              <strong>สถานะเกม</strong>
              <Switch label="เข้าทันที" checked={filters.instant} onChange={(v) => setFilters((p) => ({ ...p, instant: v }))} />
              <Switch label="เปิดให้บริการ" checked={filters.available} onChange={(v) => setFilters((p) => ({ ...p, available: v }))} />
            </div>

            <div className="lt-filter__group">
              <strong>ประเภทแพ็ก</strong>
              <Switch label="มีโปรโมชั่น" checked={filters.promo} onChange={(v) => setFilters((p) => ({ ...p, promo: v }))} />
            </div>
          </aside>

          <div>
            {filtered === null ? (
              <SkeletonGrid count={18} height={190} />
            ) : groups.length === 0 ? (
              <div className="lt-panel lt-panel--plain lt-empty">ไม่พบเกมที่ค้นหา</div>
            ) : (
              groups.map((group) => (
                <div className="lt-server-group" key={group.key}>
                  <div className="lt-section-title" style={{ marginTop: 0 }}>
                    <span className="lt-section-title__bar" />
                    <div>
                      <h2>{group.title}</h2>
                    </div>
                  </div>
                  <div className="lt-tile-grid">
                    {group.rows.map((game) => (
                      <GameTile key={game.id} game={game} />
                    ))}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
}
